import { render, staticRenderFns } from "./TripDurationDropdown.vue?vue&type=template&id=4ff3e2c5&scoped=true"
import script from "./TripDurationDropdown.vue?vue&type=script&lang=js"
export * from "./TripDurationDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff3e2c5",
  null
  
)

export default component.exports